import axios from 'axios';
import React,{useEffect} from 'react'

function TermsAndConditions() {
    useEffect(() => {
          const backendUrl = import.meta.env.VITE_BACKEND_URL; // ✅ dynamic URL
          axios.post(`${backendUrl}/api/analytics/visit`, { page: "Term And Conditions" })
            .then(res => console.log(" visit recorded:", res.data))
            .catch(err => console.error("Analytics error:", err));
        }, []);
  return (
    <div className="px-10 lg:px-28 py-6">
      {/* Centered Title */}
      <h1 className="text-2xl font-bold text-center mb-8 text-[#FF4902]">Terms and Conditions</h1>

      {/* Content */}
      <p className="mb-4 font-semibold">
        PLEASE READ THESE TERMS CAREFULLY. BY SIGNING UP TO AND/OR USING THIS PLATFORM AND OUR SERVICES, YOU AGREE TO BE BOUND BY ALL OF THE BELOW TERMS AND CONDITIONS AND PRIVACY POLICY.
      </p>
      <p className="mb-4">
        The website at{' '}
        <a href="http://www.mammothstreetwears.com" className="text-blue-600 underline">
          www.mammothstreetwears.com
        </a>{' '}
        (“Website”) is owned and operated by Mammoth Streetwears Private Limited (“Mammoth Streetwears,” “we,” “us,” “our” and their respective connotations). The Website is collectively referred to as the “Platform” for buying clothes.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">1. General</h2>
      <p className="mb-4">
        By accessing our website and using our services, you agree to comply with and be bound by these Terms and Conditions, as well as our Privacy Policy and any other applicable policies. If you do not agree with these Terms, please do not use our services.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">2. Account Registration</h2>
      <p className="mb-4">
        To make a purchase, you may be required to create an account on our website. You agree to provide accurate, current, and complete information during the registration process. You are responsible for maintaining the confidentiality of your account information and for all activities that occur under your account.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">3. Products and Availability</h2>
      <p className="mb-4">
        All products are subject to availability. We reserve the right to modify, discontinue, or limit the quantity of any product at any time without notice. While we make every effort to display the products accurately on our website, colors, designs, and features may vary slightly due to differences in screen displays or production variations.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">4. Pricing and Payment</h2>
      <ul className="list-disc ml-6 mb-4">
        <li>Prices for products are listed in ₹ and are subject to change without notice.</li>
        <li>Payments can be made using major credit/debit cards, PayPal, or other payment methods available on our site.</li>
        <li>Taxes, shipping costs, and other fees may apply and will be added to the total price at checkout.</li>
        <li>We reserve the right to correct any pricing errors, even after an order has been placed, and may cancel orders due to incorrect pricing.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">5. Shipping and Delivery</h2>
      <p className="mb-4">
        We offer domestic and international shipping to the locations specified on our website. Shipping times may vary depending on your location. We provide estimated delivery times, but we do not guarantee delivery dates. You are responsible for providing an accurate shipping address. We are not liable for orders that are lost due to incorrect shipping information provided by you.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">6. Returns and Exchanges</h2>
      <p className="mb-4">
        We accept returns and exchanges within 7 days after delivery, provided the items are in their original, unused condition, with tags still attached. Items that are worn, washed, or damaged are not eligible for return or exchange. Shipping costs for returns and exchanges are the responsibility of the customer, unless the return is due to a defect or error on our part.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">7. Cancellations</h2>
      <p className="mb-4">
        If you wish to cancel an order, please contact us as soon as possible. If the order has not been processed or shipped, we will attempt to cancel the order. Once the order is shipped, we are unable to cancel it, and the standard return policy will apply.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">8. Intellectual Property</h2>
      <p className="mb-4">
        All content on our website, including logos, text, graphics, images, and designs, are the property of Mammoth Streetwears and are protected by copyright, trademark, and other intellectual property laws. You may not use any of our content without prior written permission from us.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">9. User Content</h2>
      <p className="mb-4">
        If you submit reviews, comments, or any other content (such as photos or videos) on our website or social media pages, you grant Mammoth Streetwears a non-exclusive, royalty-free, perpetual, and worldwide license to use, modify, and distribute such content for marketing or promotional purposes.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">10. Prohibited Activities</h2>
      <p className="mb-4">
        You agree not to engage in the following activities while using our website:
        <ul className="list-disc ml-6">
          <li>Violating any applicable laws or regulations.</li>
          <li>Infringing upon the intellectual property rights of Mammoth Streetwears or third parties.</li>
          <li>Disrupting the functionality of the website, or attempting to gain unauthorized access to our systems.</li>
        </ul>
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">11. Limitation of Liability</h2>
      <p className="mb-4">
        To the fullest extent permitted by law, Mammoth Streetwears shall not be liable for any indirect, incidental, special, or consequential damages arising out of your use of our products or website, even if we have been advised of the possibility of such damages.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">12. Indemnification</h2>
      <p className="mb-4">
        You agree to indemnify and hold harmless Mammoth Streetwears, its affiliates, officers, employees, and agents from any claims, liabilities, damages, and expenses (including reasonable attorneys' fees) arising from your violation of these Terms, or your use of our website and products.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">13. Privacy Policy</h2>
      <p className="mb-4">
        Your use of our website and purchase of our products is also governed by our Privacy Policy. Please review our Privacy Policy [insert link to Privacy Policy] to understand how we collect, use, and protect your personal information.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">14. Amendments</h2>
      <p className="mb-4">
        We reserve the right to update or modify these Terms at any time. Any changes will be posted on this page with the updated effective date. By continuing to use our website and services, you agree to be bound by the revised Terms.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">15. Governing Law</h2>
      <p className="mb-4">
        These Terms are governed by the laws of India, without regard to its conflict of law principles. Any disputes arising from these Terms will be resolved in the courts located in Pune, India.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">16. Contact Us</h2>
      <p className="mb-4">
        If you have any questions or concerns about these Terms, please contact us at:
      </p>
      <address className="mb-4">
        <strong>Mammoth Streetwears</strong> <br />
        Email:{' '}
        <a href="mailto:info@mammothstreetwears.com" className="text-blue-600 underline">
          info@mammothstreetwears.com
        </a>{' '}
        <br />
        Phone:{' '}
        <a href="tel:+7276765568" className="text-blue-600 underline">
          7276765568
        </a>{' '}
        <br />
        Address: Office No-102, Kalpana Tarang Apt, Opp. Ranka Jewellers, Karve Road, Erandwane, Pune-411004
      </address>
    </div>
  );
}

export default TermsAndConditions;
